import { useState } from "react";
import { Head, router } from "@inertiajs/react";
import { toast } from "sonner";

import { Button } from "@/components/ui/button";
import H3 from "@/components/ui/h1";

export default function InviteShow({
  invite,
  token,
}) {
  const [processing, setProcessing] = useState(false);

  const handleErrors = (errors) => {
    if (errors.user_id) {
      errors.user_id.forEach(error => {
        toast.error(`User ${error}`);
      });
    }

    if (errors.base) {
      errors.base.forEach(error => {
        toast.error(error);
      });
    }
  };

  const handleAccept = () => {
    router.post(`/invites/${invite.id}/accept`, { token }, {
      onError: handleErrors,
      onStart: () => setProcessing(true),
      onFinish: () => setProcessing(false),
    });
  };

  const handleReject = () => {
    router.post(`/invites/${invite.id}/reject`, { token }, {
      onError: handleErrors,
      onStart: () => setProcessing(true),
      onFinish: () => setProcessing(false),
    });
  };

  return (
    <div className="flex flex-1 justify-center">
      <Head title={`Invitation to join ${invite.team.name}`} />
      <div className="flex flex-col text-center gap-4 max-w-120 mt-[15%]">
        <H3>You got invited to join "{invite.team.name}"</H3>

        <div className="flex gap-4 justify-center">
          <Button onClick={handleAccept} disabled={processing}>Accept</Button>
          <Button onClick={handleReject} disabled={processing} variant="outline">Reject</Button>
        </div>
      </div>
    </div>
  );
}
